var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  YayoyakiFormatter: () => YayoyakiFormatter
});
var import_definition2 = __toModule(require("./definition"));
class YayoyakiFormatter {
  static formatDate(value) {
    const newValue = value.toString();
    const dd = newValue.substring(0, 2);
    const mm = newValue.substring(2, 4);
    const yy = newValue.substring(4);
    return `${dd}/${mm}/${yy}`;
  }
  static formatAmountEuro(value) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "symbol"
    }).format(value).replace(/\xa0/, "");
  }
  static formatAmountMxn(value) {
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      currencyDisplay: "symbol"
    }).format(value);
  }
  static formatPercentage(value) {
    return value.toString().concat(" %");
  }
  static hasFormatter(value, type) {
    return Object.values(import_definition2.FormatsTypes).includes(type) && value !== null && value !== void 0;
  }
  static formatValue(value, type) {
    if (type === import_definition2.FormatsTypes.DATE) {
      return this.formatDate(value);
    }
    if (type === import_definition2.FormatsTypes.AMOUNT_EURO) {
      return this.formatAmountEuro(value);
    }
    if (type === import_definition2.FormatsTypes.AMOUNT_DOLLAR_MXN) {
      return this.formatAmountMxn(value);
    }
    if (type === import_definition2.FormatsTypes.PERCENTAGE) {
      return this.formatPercentage(value);
    }
    throw new Error(`Not exist formatter for type: ${type}`);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  YayoyakiFormatter
});
